import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledCheckBoxWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

export const StyledCheckBoxList = styled.ul`
  display: flex;
  margin: 0;
`;

export const StyledCheckBoxItem = styled.li`
  list-style: none;
  text-decoration: none;

  &:not(:last-child) {
    margin-right: 10px;
  }
`;

export const StyledLabel = styled.label`
  align-items: center;
  display: flex;
  gap: 6px;
`;

export const StyledLabelText = styled.span`
  display: flex;
  align-items: center;
  color: ${themeGet('colors.primary.extra')};
  font-size: ${themeGet('fontSizes.xs')}px;
  font-weight: ${themeGet('fontWeights.semi')};
`;
